setUpdateUserProcessing